"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themePrimaryColors = void 0;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var themePrimaryColors = function themePrimaryColors(color) {
  return [color, // [0] $primary
  (0, _color.default)(color).saturate(0.048).darken(0.38).hex(), //[1] $primary-dark
  (0, _color.default)(color).desaturate(0.145).lighten(0.467).hex(), // [2] $primary-mid
  (0, _color.default)(color).rotate(1).saturate(0.103).lighten(1.27).hex() //[3] $primary-light
  ];
};

exports.themePrimaryColors = themePrimaryColors;